/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

const buildQuery = (params = {}) => {
    const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
        acc[k] = Array.isArray(v) ? v.join(',') : v;
        return acc;
    }, {});
    const qs = new URLSearchParams(cleaned).toString();
    return qs ? `?${qs}` : '';
};

export default {
    getAll: async (params) => exeRequest(`/admin/agences${buildQuery(params)}`, "GET"),

    getById: async (id) => exeRequest(`/admin/agences/${id}`, "GET"),

    create: async (data) => exeRequest(`/admin/agences`, "POST", data),

    update: async (id, data) => exeRequest(`/admin/agences/${id}`, "PUT", data),

    delete: async (id) => exeRequest(`/admin/agences/${id}`, "DELETE"),

    toggle: async (id, isActive) => exeRequest(`/admin/agences/${id}/toggle`, "PATCH", { isActive }),
};
